function attach_product_to_license(sender, license_id) {
    var $ = jQuery.noConflict();

    var form = $(sender);
    var data = form.serializeJSON();

    data.license_id = license_id;
    if(parseInt(data.product_id) > 0 && parseInt(data.license_id) > 0) {

        $('body').isLoading('dark');
        $.post("/company/admin/addModule",data, function(data) {
            $('body').doneLoading();
            $('.modules-table').reloadThisElement();
        });
    }
    return false;
}